import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app/App";
import { registerPedEmUpPwa } from "./platform/pwa";
import "./styles/globals.css";

const mount = document.querySelector<HTMLDivElement>("#app");
if (!mount) throw new Error("PedEmUP application root was not found.");

if (!__PEDEMUP_COMPOSED_BUILD__) registerPedEmUpPwa();

createRoot(mount).render(
  <StrictMode>
    <BrowserRouter basename={__PEDEMUP_ROUTER_BASENAME__}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
